import React from 'react';
import './styles1.css';

function Footer() {
    return (
        <footer className="footer">
            <p>Copyright @ 2025</p>
        </footer>
    );
}

export default Footer;